import React, { useEffect, useState, useCallback, useRef } from "react";

import { useParams } from "react-router-dom";

import axios from "axios";

import { toast, ToastContainer } from "react-toastify";

import "../../styles/incoming-mail.css";

import { playNotificationSound } from "../../utils/playNotificationSound";

import RichTextToolbar, { RichTextEditor } from "../../components/RichTextToolbar";
import ImageResizeBar, {
    applyImageDisplayWidth,
    getImageDisplayWidth,
    compressImageDataUrl,
} from "../../components/ImageResizeBar";
import {
    initComposeImageHandlers,
    enhanceExistingComposeImages,
    serializeEditorHtml,
    insertComposeImage,
} from "../../utils/composeImageResize";

import {

    MAIL_FOLDERS,

    getInitials,

    formatDisplayDate,

    extractSenderName,
    formatMailboxLabel,
    getMailSignature,
    getMailSignatureHtml,
    saveMailSignature,
    saveMailSignatureHtml,
    formatAttachmentSize,
    totalAttachmentSize,
    getAttachmentIcon,
    buildReplyAllRecipients,
    buildReplyComposeBody,
    buildReplyComposeHtml,
    appendSignatureHtmlToDraft,
    appendSignatureToBody,
    getComposeSignatureHtml,
    plainTextFromEmailBody,
    TRANSLATE_LANGUAGES,
    fixEmailDisplayText,
} from "../../utils/mailHelpers";

import { crmHeaders, crmMultipartHeaders } from "../../utils/crmApi";

import { canUseEmailForCountry } from "../../utils/userAccess";

import { EmailCountBadge, useEmailNotifications } from "../../context/EmailNotificationContext";
import { useTheme } from "../../context/ThemeContext";
import EmailHealthAlert from "../../components/EmailHealthAlert";
import { useEmailHealth } from "../../context/EmailHealthContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const POLL_INTERVAL_MS = 25000;
const MAX_COMPOSE_ATTACHMENTS = 10;
const MAX_ATTACHMENT_SIZE_BYTES = 50 * 1024 * 1024;
const LIST_WIDTH_KEY = "crm_mail_list_width";
const LIST_MIN_WIDTH = 220;
const LIST_MAX_WIDTH = 700;
const READ_FONT_KEY = "crm_mail_read_font";



export default function IncomingMail() {

    const { country: countryParam } = useParams();

    const countryFilter = countryParam ? decodeURIComponent(countryParam) : null;



    const [accounts, setAccounts] = useState([]);

    const [accountsLoading, setAccountsLoading] = useState(true);

    const [activeAccount, setActiveAccount] = useState(null);

    const [activeFolder, setActiveFolder] = useState("inbox");

    const [availableFolders, setAvailableFolders] = useState(MAIL_FOLDERS.map((f) => f.key));

    const [messages, setMessages] = useState([]);

    const [messagesLoading, setMessagesLoading] = useState(false);

    const [selectedMessage, setSelectedMessage] = useState(null);

    const [messageLoading, setMessageLoading] = useState(false);

    const [searchQuery, setSearchQuery] = useState("");

    const [showCompose, setShowCompose] = useState(false);

    const [replySubject, setReplySubject] = useState("");

    const [replyBody, setReplyBody] = useState("");

    const [replyTo, setReplyTo] = useState("");
    const [replyCc, setReplyCc] = useState("");
    const [replyBcc, setReplyBcc] = useState("");
    const [composeAttachments, setComposeAttachments] = useState([]);

    const [sendingReply, setSendingReply] = useState(false);
    const [aiSuggestLoading, setAiSuggestLoading] = useState(false);
    const [composeMode, setComposeMode] = useState("reply");
    const [showCcBcc, setShowCcBcc] = useState(false);
    const [folderCounts, setFolderCounts] = useState({});
    const [messageLimit, setMessageLimit] = useState(1000);
    const [totalInFolder, setTotalInFolder] = useState(0);
    const [movingEmail, setMovingEmail] = useState(false);
    const [deletingEmail, setDeletingEmail] = useState(false);
    const [emptyingTrash, setEmptyingTrash] = useState(false);
    const [savingDraft, setSavingDraft] = useState(false);
    const [attachmentLoading, setAttachmentLoading] = useState(null);
    const [previewAttachment, setPreviewAttachment] = useState(null);
    const [requestReadReceipt, setRequestReadReceipt] = useState(false);
    const [focusedListUid, setFocusedListUid] = useState(null);
    const [selectedUids, setSelectedUids] = useState(() => new Set());
    const [bulkDeleting, setBulkDeleting] = useState(false);
    const [listPanelWidth, setListPanelWidth] = useState(() => {
        try {
            const v = parseInt(localStorage.getItem(LIST_WIDTH_KEY), 10);
            return v >= LIST_MIN_WIDTH && v <= LIST_MAX_WIDTH ? v : 340;
        } catch {
            return 340;
        }
    });
    const [listPanelHidden, setListPanelHidden] = useState(false);
    const [showAttachDropdown, setShowAttachDropdown] = useState(false);
    const [readAttachOpen, setReadAttachOpen] = useState(false);
    const [readFontSize, setReadFontSize] = useState(() => {
        try {
            const v = localStorage.getItem(READ_FONT_KEY);
            return v === "sm" || v === "lg" ? v : "md";
        } catch {
            return "md";
        }
    });
    const [showSignatureEditor, setShowSignatureEditor] = useState(false);
    const [signatureImageWidth, setSignatureImageWidth] = useState(200);
    const [showSignatureImageResize, setShowSignatureImageResize] = useState(false);
    const [signatureText, setSignatureText] = useState("");
    const [detectedLanguage, setDetectedLanguage] = useState(null);
    const [translateTarget, setTranslateTarget] = useState("en");
    const [translateLoading, setTranslateLoading] = useState(false);
    const [emailViewMode, setEmailViewMode] = useState("original");
    const [translatedEmailHtml, setTranslatedEmailHtml] = useState("");
    const filteredMessagesRef = useRef([]);
    const listResizeRef = useRef({ active: false, startX: 0, startW: 340 });
    const listPanelWidthRef = useRef(listPanelWidth);

    const knownUidsRef = useRef(new Set());
    const messageCacheRef = useRef(new Map());
    const composeFileInputRef = useRef(null);
    const composeEditorRef = useRef(null);
    const signatureEditorRef = useRef(null);
    const signatureImageInputRef = useRef(null);
    const selectedSignatureImageRef = useRef(null);
    const pendingComposeHtmlRef = useRef("");

    const pollingReadyRef = useRef(false);

    const { byEmail, refresh: refreshEmailNotifications } = useEmailNotifications();
    const { getHealthForEmail, blockedCount, issueCount } = useEmailHealth();
    const { darkMode, toggleDarkMode, hideSidebar, showSidebar } = useTheme();

    const activeAccountHealth = activeAccount ? getHealthForEmail(activeAccount.Email) : null;

    useEffect(() => {
        if (selectedMessage) {
            hideSidebar();
        } else {
            showSidebar();
        }
    }, [selectedMessage, hideSidebar, showSidebar]);

    useEffect(() => {
        setSelectedUids(new Set());
    }, [activeFolder, activeAccount?.Email]);

    useEffect(() => {
        if (activeAccount?.Email) {
            setSignatureText(getMailSignature(activeAccount.Email));
        }
    }, [activeAccount?.Email]);

    useEffect(() => {
        if (showCompose && composeEditorRef.current && pendingComposeHtmlRef.current) {
            composeEditorRef.current.innerHTML = pendingComposeHtmlRef.current;
            enhanceExistingComposeImages(composeEditorRef.current);
        }
    }, [showCompose]);

    useEffect(() => {
        if (!showCompose || !composeEditorRef.current) return;
        initComposeImageHandlers(composeEditorRef.current, { initKey: "compose" });
    }, [showCompose]);

    useEffect(() => {
        if (showSignatureEditor && signatureEditorRef.current && activeAccount?.Email) {
            signatureEditorRef.current.innerHTML = getMailSignatureHtml(activeAccount.Email);
            enhanceExistingComposeImages(signatureEditorRef.current);
        }
    }, [showSignatureEditor, activeAccount?.Email]);

    useEffect(() => {
        if (!showSignatureEditor || !signatureEditorRef.current) return;
        initComposeImageHandlers(signatureEditorRef.current, { initKey: "signature" });
    }, [showSignatureEditor]);

    const setComposeEditorHtml = (html) => {
        pendingComposeHtmlRef.current = html || "";
        if (composeEditorRef.current) {
            composeEditorRef.current.innerHTML = pendingComposeHtmlRef.current;
            enhanceExistingComposeImages(composeEditorRef.current);
        }
    };

    const syncComposeHtmlRef = () => {
        if (composeEditorRef.current) {
            pendingComposeHtmlRef.current = composeEditorRef.current.innerHTML;
        }
    };

    const getComposeEditorHtml = (forSend = false) => {
        const editor = composeEditorRef.current;
        if (editor) {
            return forSend ? serializeEditorHtml(editor) : editor.innerHTML?.trim() || "";
        }
        return pendingComposeHtmlRef.current || replyBody || "";
    };

    const ensureSignatureInCompose = () => {
        const editor = composeEditorRef.current;
        if (!editor || !activeAccount?.Email) return;

        const sigHtml = getComposeSignatureHtml(activeAccount.Email);
        if (!sigHtml) return;

        const current = editor.innerHTML || "";
        const sigKey = sigHtml.slice(0, Math.min(60, sigHtml.length));
        if (sigKey && current.includes(sigKey)) return;

        const quoteMatch = current.search(/<hr[\s>]|<blockquote[\s>]/i);
        if (quoteMatch > -1) {
            editor.innerHTML = `${current.slice(0, quoteMatch)}${sigHtml}<br><br>${current.slice(quoteMatch)}`;
        } else {
            editor.innerHTML = current.trim()
                ? `${sigHtml}<br><br>${current}`
                : sigHtml;
        }
        enhanceExistingComposeImages(editor);
        syncComposeHtmlRef();
    };

    const resetEmailTranslation = () => {
        setEmailViewMode("original");
        setTranslatedEmailHtml("");
        setDetectedLanguage(null);
    };

    const getReadEmailPlainText = (msg) => {
        if (!msg) return "";
        return plainTextFromEmailBody(msg.isHtml ? msg.body : String(msg.body || "").replace(/\n/g, "<br>"));
    };

    const handleDetectLanguage = async () => {
        if (!selectedMessage) return;
        setTranslateLoading(true);
        try {
            const res = await axios.post(
                `${BASE_URL}/ai/email-detect-language`,
                { text: getReadEmailPlainText(selectedMessage) },
                { headers: crmHeaders() }
            );
            setDetectedLanguage({
                code: res.data.languageCode,
                name: res.data.languageName,
            });
            toast.success(`Language: ${res.data.languageName}`);
        } catch (error) {
            toast.error(error.response?.data?.message || "Could not detect language");
        } finally {
            setTranslateLoading(false);
        }
    };

    const handleTranslateEmail = async () => {
        if (!selectedMessage) return;
        const target = TRANSLATE_LANGUAGES.find((l) => l.code === translateTarget);
        setTranslateLoading(true);
        try {
            const res = await axios.post(
                `${BASE_URL}/ai/email-translate`,
                {
                    text: getReadEmailPlainText(selectedMessage),
                    targetLanguage: target?.label || translateTarget,
                    sourceLanguage: detectedLanguage?.name,
                },
                { headers: crmHeaders() }
            );
            const translated = res.data.translated || "";
            setTranslatedEmailHtml(translated.replace(/\n/g, "<br>"));
            setEmailViewMode("translated");
            if (res.data.detectedLanguage) {
                setDetectedLanguage({
                    code: res.data.detectedLanguageCode || detectedLanguage?.code,
                    name: res.data.detectedLanguage,
                });
            }
            toast.success(`Translated to ${target?.label || translateTarget}`);
        } catch (error) {
            toast.error(error.response?.data?.message || "Translation failed");
        } finally {
            setTranslateLoading(false);
        }
    };

    useEffect(() => {
        listPanelWidthRef.current = listPanelWidth;
    }, [listPanelWidth]);

    useEffect(() => {
        const onMove = (e) => {
            if (!listResizeRef.current.active) return;
            const next = Math.min(
                LIST_MAX_WIDTH,
                Math.max(LIST_MIN_WIDTH, listResizeRef.current.startW + (e.clientX - listResizeRef.current.startX))
            );
            setListPanelWidth(next);
        };
        const onUp = () => {
            if (!listResizeRef.current.active) return;
            listResizeRef.current.active = false;
            document.body.classList.remove("outlook-resizing");
            try {
                localStorage.setItem(LIST_WIDTH_KEY, String(listPanelWidthRef.current));
            } catch {
                /* ignore */
            }
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
        return () => {
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
        };
    }, []);

    const startListResize = (e) => {
        e.preventDefault();
        listResizeRef.current = { active: true, startX: e.clientX, startW: listPanelWidth };
        document.body.classList.add("outlook-resizing");
    };

    const insertSignature = () => {
        const sigHtml = getComposeSignatureHtml(activeAccount?.Email);
        if (!sigHtml) {
            toast.info("Add your signature first (Edit signature below — paste PNG/JPG image)");
            setShowSignatureEditor(true);
            return;
        }
        const editor = composeEditorRef.current;
        if (editor) {
            const block = document.createElement("div");
            block.innerHTML = sigHtml;
            editor.appendChild(document.createElement("br"));
            editor.appendChild(block);
            enhanceExistingComposeImages(editor);
            syncComposeHtmlRef();
            editor.focus();
        }
    };

    const handleSaveSignature = async () => {
        if (!activeAccount?.Email || !signatureEditorRef.current) return;
        try {
            let html = serializeEditorHtml(signatureEditorRef.current) || signatureText;
            const temp = document.createElement("div");
            temp.innerHTML = html;
            const imgs = temp.querySelectorAll('img[src^="data:image"]');
            for (const img of imgs) {
                const width = parseInt(img.style.width || img.getAttribute("width") || "240", 10);
                img.src = await compressImageDataUrl(img.src, Math.min(600, width + 80));
            }
            html = temp.innerHTML.trim();
            saveMailSignatureHtml(activeAccount.Email, html);
            setSignatureText(getMailSignature(activeAccount.Email));
            signatureEditorRef.current.innerHTML = html;
            enhanceExistingComposeImages(signatureEditorRef.current);
            toast.success("Signature saved (text + images)");
        } catch (error) {
            toast.error(
                error?.name === "QuotaExceededError"
                    ? "Signature image too large — resize smaller and save again"
                    : "Could not save signature"
            );
        }
    };

    const appendSignatureImageNode = async (editor, dataUrl, width = 200) => {
        await insertComposeImage(editor, dataUrl, width);
    };

    const handleSignatureImageWidthChange = (width) => {
        setSignatureImageWidth(width);
        if (selectedSignatureImageRef.current) {
            applyImageDisplayWidth(selectedSignatureImageRef.current, width);
        }
    };

    const handleSignatureEditorClick = (event) => {
        if (event.target?.tagName === "IMG") {
            selectedSignatureImageRef.current = event.target;
            setSignatureImageWidth(getImageDisplayWidth(event.target));
            setShowSignatureImageResize(true);
            return;
        }
        selectedSignatureImageRef.current = null;
        setShowSignatureImageResize(false);
    };

    const handleSignatureImageUpload = (event) => {
        const file = event.target.files?.[0];
        if (!file || !signatureEditorRef.current) return;
        const okType = /image\/(png|jpe?g|avif|webp|gif)/i.test(file.type) ||
            /\.(png|jpe?g|avif|webp|gif)$/i.test(file.name);
        if (!okType) {
            toast.error("Use PNG, JPG, JPEG, AVIF, or WEBP image");
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            appendSignatureImageNode(signatureEditorRef.current, reader.result, signatureImageWidth);
        };
        reader.readAsDataURL(file);
        event.target.value = "";
    };

    const handleSignaturePaste = (e) => {
        const items = e.clipboardData?.items;
        if (!items || !signatureEditorRef.current) return;
        for (const item of items) {
            if (item.type.startsWith("image/")) {
                e.preventDefault();
                const file = item.getAsFile();
                if (!file) continue;
                const reader = new FileReader();
                reader.onload = () => {
                    appendSignatureImageNode(signatureEditorRef.current, reader.result, signatureImageWidth);
                };
                reader.readAsDataURL(file);
                return;
            }
        }
    };

    const setReadFontSizePersist = (size) => {
        setReadFontSize(size);
        try {
            localStorage.setItem(READ_FONT_KEY, size);
        } catch {
            /* ignore */
        }
    };



    useEffect(() => {

        setAccountsLoading(true);

        setActiveAccount(null);

        setMessages([]);

        setSelectedMessage(null);

        pollingReadyRef.current = false;

        knownUidsRef.current = new Set();



        const url = countryFilter

            ? `${BASE_URL}/getemails?country=${encodeURIComponent(countryFilter)}`

            : `${BASE_URL}/getemails`;



        axios

            .get(url, { headers: crmHeaders() })

            .then((res) => {

                setAccounts(res.data || []);

                setAccountsLoading(false);

            })

            .catch(() => {

                toast.error("Failed to load email accounts");

                setAccountsLoading(false);

            });

    }, [countryFilter]);



    const loadFolderCounts = useCallback(async (account) => {

        if (!account) return;

        try {

            const res = await axios.post(

                `${BASE_URL}/getfoldercounts`,

                { Email: account.Email },

                { headers: crmHeaders() }

            );

            setFolderCounts(res.data.counts || {});

        } catch {

            /* keep existing counts on background refresh failure */

        }

    }, []);



    const loadAccountOverview = useCallback(

        async (account, folder = "inbox") => {

            if (!account) return;

            setMessagesLoading(true);

            setSelectedMessage(null);

            setShowCompose(false);

            try {

                const res = await axios.post(

                    `${BASE_URL}/getmailoverview`,

                    { Email: account.Email, limit: messageLimit, folder },

                    { headers: crmHeaders() }

                );

                const keys = (res.data.folders || [])

                    .filter((f) => f.available)

                    .map((f) => f.key);

                if (keys.length > 0) setAvailableFolders(keys);

                setFolderCounts(res.data.counts || {});

                const list = res.data.emails || [];

                setMessages(list);
                setTotalInFolder(res.data.totalInFolder ?? list.length);

                knownUidsRef.current = new Set(list.map((m) => m.uid));

                if (folder === "inbox") pollingReadyRef.current = true;

            } catch (error) {

                const msg = error.response?.data?.message || "Failed to load messages";

                toast.error(msg);

                setMessages([]);

            } finally {

                setMessagesLoading(false);

            }

        },

        [messageLimit]

    );



    const fetchMessages = useCallback(

        async (account, folder, { silent = false, notify = false } = {}) => {

            if (!account) return;

            if (!silent) setMessagesLoading(true);

            if (!silent) {

                setSelectedMessage(null);

                setShowCompose(false);

            }



            try {

                const res = await axios.post(

                    `${BASE_URL}/getinbox`,

                    { Email: account.Email, limit: messageLimit, folder },

                    { headers: crmHeaders() }

                );

                const list = res.data.emails || [];

                setMessages(list);
                setTotalInFolder(res.data.total ?? list.length);



                if (folder === "inbox" && notify && pollingReadyRef.current) {

                    const newOnes = list.filter(

                        (m) => !knownUidsRef.current.has(m.uid)

                    );

                    if (newOnes.length > 0) {

                        playNotificationSound();

                        const first = newOnes[0];

                        toast.info(

                            <div className="email-notif-popup">

                                <div className="email-notif-popup-icon">

                                    <i className="bi bi-envelope-fill"></i>

                                </div>

                                <div className="email-notif-popup-body">

                                    <strong>

                                        {newOnes.length > 1

                                            ? `${newOnes.length} new emails`

                                            : "New email"}{" "}

                                        — {account.Email}

                                    </strong>

                                    <span className="email-notif-popup-subject">

                                        {first.subject || "(No subject)"}

                                    </span>

                                    <small>From: {extractSenderName(first.from)}</small>

                                </div>

                            </div>,

                            { autoClose: 7000, icon: false }

                        );

                    }

                }



                knownUidsRef.current = new Set(list.map((m) => m.uid));

                if (folder === "inbox") pollingReadyRef.current = true;

            } catch (error) {

                if (silent) {
                    try {
                        const retry = await axios.post(
                            `${BASE_URL}/getinbox`,
                            { Email: account.Email, limit: messageLimit, folder },
                            { headers: crmHeaders() }
                        );
                        const list = retry.data.emails || [];
                        setMessages(list);
                        setTotalInFolder(retry.data.total ?? list.length);
                        knownUidsRef.current = new Set(list.map((m) => m.uid));
                        return;
                    } catch {
                        /* fall through */
                    }
                }

                if (!silent) {

                    const msg = error.response?.data?.message || "Failed to load messages";

                    toast.error(msg);

                    setMessages([]);

                }

            } finally {

                if (!silent) setMessagesLoading(false);

            }

        },

        [messageLimit]

    );



    const loadMoreMessages = useCallback(async () => {

        if (!activeAccount) return;

        const nextLimit = Math.min(messageLimit + 500, 2000);

        if (nextLimit === messageLimit) return;

        setMessageLimit(nextLimit);

        setMessagesLoading(true);

        try {

            const res = await axios.post(

                `${BASE_URL}/getmailoverview`,

                { Email: activeAccount.Email, limit: nextLimit, folder: activeFolder },

                { headers: crmHeaders() }

            );

            const list = res.data.emails || [];

            setMessages(list);

            setTotalInFolder(res.data.totalInFolder ?? list.length);

            knownUidsRef.current = new Set(list.map((m) => m.uid));

        } catch (error) {

            toast.error(error.response?.data?.message || "Could not load more messages");

        } finally {

            setMessagesLoading(false);

        }

    }, [activeAccount, activeFolder, messageLimit]);



    const selectAccount = useCallback(

        (account) => {

            setMessageLimit(150);

            setTotalInFolder(0);

            setActiveAccount(account);

            setSelectedMessage(null);

            setShowCompose(false);

            setSearchQuery("");

            setActiveFolder("inbox");

            pollingReadyRef.current = false;

            knownUidsRef.current = new Set();

            messageCacheRef.current.clear();

            loadAccountOverview(account, "inbox");

        },

        [loadAccountOverview]

    );



    useEffect(() => {

        if (accountsLoading || accounts.length === 0 || activeAccount) return;

        selectAccount(accounts[0]);

    }, [accounts, accountsLoading, activeAccount, selectAccount]);



    const switchFolder = (folderKey) => {

        if (!activeAccount) return;

        setActiveFolder(folderKey);

        setSelectedMessage(null);

        messageCacheRef.current.clear();

        fetchMessages(activeAccount, folderKey);

    };



    useEffect(() => {

        if (!activeAccount || activeFolder !== "inbox") return undefined;



        const timer = setInterval(() => {

            fetchMessages(activeAccount, "inbox", { silent: true, notify: true });

        }, POLL_INTERVAL_MS);



        return () => clearInterval(timer);

    }, [activeAccount, activeFolder, fetchMessages]);



    const applyOpenedMessage = (msg, uid) => {
        setSelectedMessage(msg);
        setFocusedListUid(uid);
        setReadAttachOpen((msg.attachments?.length || 0) <= 1);
        resetEmailTranslation();
    };

    const openMessage = async (uid) => {

        if (!activeAccount) return;

        if (previewAttachment?.url) URL.revokeObjectURL(previewAttachment.url);

        setPreviewAttachment(null);

        const cacheKey = `${activeAccount.Email}:${activeFolder}:${uid}:v6`;

        const cached = messageCacheRef.current.get(cacheKey);

        if (cached) {

            applyOpenedMessage(cached, uid);

            setShowCompose(false);

            setMessages((prev) =>
                prev.map((m) => (m.uid === uid ? { ...m, seen: true } : m))
            );

            return;

        }

        setMessageLoading(true);
        setShowCompose(false);

        const listPreview = messages.find((m) => m.uid === uid);
        if (listPreview) {
            setSelectedMessage({
                ...listPreview,
                body: "",
                isHtml: false,
                attachments: [],
                thread: [],
                fullConversation: null,
            });
        }

        try {

            const res = await axios.post(

                `${BASE_URL}/getemail`,

                { Email: activeAccount.Email, uid, folder: activeFolder },

                { headers: crmHeaders(), timeout: 90000 }

            );

            messageCacheRef.current.set(cacheKey, res.data);

            applyOpenedMessage(res.data, uid);
            setMessages((prev) =>
                prev.map((m) => (m.uid === uid ? { ...m, seen: true } : m))
            );

        } catch (error) {

            const errMsg =
                error.code === "ECONNABORTED"
                    ? "Email load timed out — server slow, try again"
                    : error.response?.data?.message || "Failed to load email";
            toast.error(errMsg);

        } finally {

            setMessageLoading(false);

        }

    };



    const resetComposeExtras = () => {

        setReplyCc("");

        setReplyBcc("");

        setComposeAttachments([]);

        setRequestReadReceipt(false);
        setShowCcBcc(false);

        if (composeFileInputRef.current) composeFileInputRef.current.value = "";

    };



    const handleAddAttachments = (event) => {

        const files = Array.from(event.target.files || []);

        if (!files.length) return;

        const validFiles = [];

        for (const file of files) {

            if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {

                toast.error(`${file.name} exceeds 50MB limit`);

                continue;

            }

            validFiles.push(file);

        }

        if (!validFiles.length) return;

        setComposeAttachments((prev) => {

            const merged = [...prev, ...validFiles];

            if (merged.length > MAX_COMPOSE_ATTACHMENTS) {

                toast.error(`Maximum ${MAX_COMPOSE_ATTACHMENTS} attachments allowed`);

                return merged.slice(0, MAX_COMPOSE_ATTACHMENTS);

            }

            return merged;

        });

        setShowAttachDropdown(true);

        event.target.value = "";

    };



    const removeComposeAttachment = (index) => {

        setComposeAttachments((prev) => prev.filter((_, i) => i !== index));

    };



    const buildComposeFormData = () => {

        const formData = new FormData();

        formData.append("Email", activeAccount.Email);

        formData.append("to", replyTo.trim());

        formData.append("subject", replySubject.trim() || "(No Subject)");

        formData.append("body", getComposeEditorHtml(true));

        if (replyCc.trim()) formData.append("cc", replyCc.trim());

        if (replyBcc.trim()) formData.append("bcc", replyBcc.trim());

        if (requestReadReceipt) formData.append("readReceipt", "true");

        if ((composeMode === "reply" || composeMode === "replyAll") && selectedMessage?.uid) {

            formData.append("markUid", String(selectedMessage.uid));

            formData.append("markFolder", activeFolder);

            if (selectedMessage.messageId) {

                formData.append("inReplyTo", selectedMessage.messageId);

                const refChain = [selectedMessage.references, selectedMessage.messageId]
                    .filter(Boolean)
                    .join(" ")
                    .trim();
                formData.append("references", refChain || selectedMessage.messageId);

            }

        }

        composeAttachments.forEach((file) => formData.append("attachments", file));

        return formData;

    };



    const startReplyCompose = (mode) => {
        if (!selectedMessage || !activeAccount) return;

        const subj = (selectedMessage.subject || "").startsWith("Re:")
            ? selectedMessage.subject
            : `Re: ${selectedMessage.subject}`;

        setComposeMode(mode);
        resetComposeExtras();
        setShowAttachDropdown(false);
        setReplySubject(subj);

        if (mode === "replyAll") {
            const serverTo = selectedMessage.replyAllTo?.trim();
            const serverCc = selectedMessage.replyAllCc?.trim();
            const computed = buildReplyAllRecipients(selectedMessage, activeAccount.Email);
            setReplyTo(serverTo || computed.replyTo || selectedMessage.replyTo || "");
            setReplyCc(serverCc || computed.replyCc || "");
            setShowCcBcc(true);
        } else {
            setReplyTo(selectedMessage.replyTo || "");
        }

        setComposeEditorHtml(buildReplyComposeHtml(selectedMessage, activeAccount.Email));
        setReplyBody("");
        setShowCompose(true);
    };

    const handleReply = () => startReplyCompose("reply");

    const handleReplyAll = () => startReplyCompose("replyAll");

    const getPlainEmailBody = (msg) => {
        if (!msg?.body) return "";
        const raw = msg.body;
        if (msg.isHtml) {
            return fixEmailDisplayText(
                raw
                    .replace(/<style[\s\S]*?<\/style>/gi, " ")
                    .replace(/<script[\s\S]*?<\/script>/gi, " ")
                    .replace(/<br\s*\/?>/gi, "\n")
                    .replace(/<\/p>/gi, "\n")
                    .replace(/<[^>]+>/g, " ")
                    .replace(/\s+/g, " ")
                    .trim()
            );
        }
        return fixEmailDisplayText(raw.trim());
    };

    const handleReplyWithAi = async () => {
        if (!selectedMessage || aiSuggestLoading) return;

        const subj = (selectedMessage.subject || "").startsWith("Re:")
            ? selectedMessage.subject
            : `Re: ${selectedMessage.subject}`;

        setComposeMode("reply");
        resetComposeExtras();
        setReplySubject(subj);
        setReplyTo(selectedMessage.replyTo || "");
        setComposeEditorHtml("");
        setReplyBody("");
        setShowCompose(true);
        setAiSuggestLoading(true);

        try {
            const res = await axios.post(
                `${BASE_URL}/ai/email-reply-suggest`,
                {
                    from: selectedMessage.from,
                    subject: selectedMessage.subject,
                    body: getPlainEmailBody(selectedMessage),
                },
                { headers: crmHeaders() }
            );
            const aiText = (res.data?.reply || "").replace(/\n/g, "<br>");
            setComposeEditorHtml(
                buildReplyComposeHtml(selectedMessage, activeAccount?.Email, `<p>${aiText}</p>`)
            );
            toast.success("AI reply ready — review and send");
        } catch (error) {
            toast.error(error.response?.data?.message || "Could not generate AI reply");
        } finally {
            setAiSuggestLoading(false);
        }
    };



    const handleNewEmail = () => {

        setComposeMode("new");

        setReplySubject("");

        setReplyTo("");

        setReplyBody("");

        setComposeEditorHtml(appendSignatureHtmlToDraft("", activeAccount?.Email));

        resetComposeExtras();
        setShowAttachDropdown(false);
        setShowSignatureEditor(false);

        setSelectedMessage(null);

        setShowCompose(true);

    };



    const sendEmail = async () => {

        if (!activeAccount) return;

        if (!replyTo.trim()) {

            toast.error("To field is required");

            return;

        }

        ensureSignatureInCompose();

        const composeHtml = getComposeEditorHtml(true);
        const hasText = plainTextFromEmailBody(composeHtml);
        const hasImages = /<img[\s>]/i.test(composeHtml);
        const hasAttachments = composeAttachments.length > 0;

        if (!hasText && !hasImages && !hasAttachments) {

            toast.error("Message or attachment is required");

            return;

        }

        setSendingReply(true);

        const wasComposeMode = composeMode;

        const repliedUid =
            wasComposeMode === "reply" || wasComposeMode === "replyAll"
                ? selectedMessage?.uid
                : null;

        try {

            const endpoint =
                composeMode === "new" ? "/sendemail" : "/replyemail";

            const res = await axios.post(

                `${BASE_URL}${endpoint}`,

                buildComposeFormData(),

                {
                    headers: crmMultipartHeaders(),
                    timeout: 180000,
                    maxBodyLength: Infinity,
                    maxContentLength: Infinity,
                }

            );

            const savedToSent = res.data?.savedToSent !== false;

            toast.success(wasComposeMode === "new" ? "Email sent successfully" : "Reply sent successfully");

            if (!savedToSent) {

                toast.warn("Email sent but could not save to Sent folder. Check server logs.");

            }

            setShowCompose(false);

            setReplyBody("");

            resetComposeExtras();

            if (repliedUid) {

                setMessages((prev) =>

                    prev.map((m) => (m.uid === repliedUid ? { ...m, answered: true } : m))

                );

                messageCacheRef.current.delete(
                    `${activeAccount.Email}:${activeFolder}:${repliedUid}:v4`
                );
                openMessage(repliedUid);

            }

            loadFolderCounts(activeAccount);

            refreshEmailNotifications();

            if (activeFolder === "sent") {

                fetchMessages(activeAccount, "sent", { silent: true });

            }

            if (wasComposeMode === "new") {

                setReplySubject("");

                setReplyTo("");

            }

        } catch (error) {

            const attachNames = composeAttachments.map((f) => f.name).join(", ");
            const errMsg = error.response?.data?.message || "Failed to send email";
            toast.error(attachNames ? `${errMsg} (files: ${attachNames})` : errMsg);

        } finally {

            setSendingReply(false);

        }

    };



    const saveDraft = async () => {

        if (!activeAccount) return;

        setSavingDraft(true);

        try {

            await axios.post(

                `${BASE_URL}/savedraft`,

                {

                    Email: activeAccount.Email,

                    to: replyTo,

                    subject: replySubject,

                    body: getComposeEditorHtml(),

                },

                { headers: crmHeaders() }

            );

            toast.success("Draft saved");

            loadFolderCounts(activeAccount);

        } catch (error) {

            toast.error(error.response?.data?.message || "Failed to save draft");

        } finally {

            setSavingDraft(false);

        }

    };



    const moveEmailToFolder = async (toFolder, successMessage) => {

        if (!activeAccount || !selectedMessage) return;

        setMovingEmail(true);

        try {

            await axios.post(

                `${BASE_URL}/moveemail`,

                {

                    Email: activeAccount.Email,

                    uid: selectedMessage.uid,

                    fromFolder: activeFolder,

                    toFolder,

                },

                { headers: crmHeaders() }

            );

            toast.success(successMessage);

            setSelectedMessage(null);

            fetchMessages(activeAccount, activeFolder);

            messageCacheRef.current.clear();

            loadFolderCounts(activeAccount);

            refreshEmailNotifications();

        } catch (error) {

            toast.error(error.response?.data?.message || "Failed to move email");

        } finally {

            setMovingEmail(false);

        }

    };



    const moveToInbox = () => moveEmailToFolder("inbox", "Moved to Inbox");



    const moveToTrash = async () => {

        if (!selectedMessage) return;

        const confirmed = window.confirm(

            "Move this email to Trash? You can restore it from Trash later."

        );

        if (!confirmed) return;

        await moveEmailToFolder("trash", "Moved to Trash");

    };



    const deleteEmailPermanently = async () => {

        if (!activeAccount || !selectedMessage) return;

        const confirmed = window.confirm(

            "Permanently delete this email? This cannot be undone."

        );

        if (!confirmed) return;

        setDeletingEmail(true);

        try {

            await axios.post(

                `${BASE_URL}/deleteemailmessage`,

                {

                    Email: activeAccount.Email,

                    uid: selectedMessage.uid,

                    folder: activeFolder,

                },

                { headers: crmHeaders() }

            );

            toast.success("Email deleted permanently");

            setSelectedMessage(null);

            setPreviewAttachment(null);

            fetchMessages(activeAccount, activeFolder);

            loadFolderCounts(activeAccount);

            refreshEmailNotifications();

        } catch (error) {

            toast.error(error.response?.data?.message || "Failed to delete email");

        } finally {

            setDeletingEmail(false);

        }

    };

    const markAsUnread = async () => {
        if (!activeAccount || !selectedMessage || activeFolder !== "inbox") return;

        try {
            await axios.post(
                `${BASE_URL}/markemailunread`,
                {
                    Email: activeAccount.Email,
                    uid: selectedMessage.uid,
                    folder: activeFolder,
                },
                { headers: crmHeaders() }
            );
            toast.success("Marked as unread");
            setMessages((prev) =>
                prev.map((m) => (m.uid === selectedMessage.uid ? { ...m, seen: false } : m))
            );
            setSelectedMessage((prev) => (prev ? { ...prev, seen: false } : prev));
            refreshEmailNotifications();
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to mark as unread");
        }
    };

    const navigateListMessage = (direction) => {
        const list = filteredMessagesRef.current;
        if (!list.length) return;

        const currentUid = selectedMessage?.uid ?? focusedListUid ?? list[0]?.uid;
        let idx = list.findIndex((m) => m.uid === currentUid);
        if (idx < 0) idx = direction > 0 ? -1 : 0;

        const nextIdx = idx + direction;
        if (nextIdx < 0 || nextIdx >= list.length) return;

        const nextUid = list[nextIdx].uid;
        setFocusedListUid(nextUid);
        openMessage(nextUid);
    };

    const openFocusedOrFirstMessage = () => {
        const list = filteredMessagesRef.current;
        if (!list.length) return;
        const uid = focusedListUid || list[0].uid;
        setFocusedListUid(uid);
        openMessage(uid);
    };

    const toggleSelectUid = (uid) => {
        setSelectedUids((prev) => {
            const next = new Set(prev);
            if (next.has(uid)) next.delete(uid);
            else next.add(uid);
            return next;
        });
    };

    const toggleSelectAllVisible = () => {
        const list = filteredMessagesRef.current;
        setSelectedUids((prev) => {
            if (prev.size === list.length && list.length > 0) return new Set();
            return new Set(list.map((m) => m.uid));
        });
    };

    const clearSelectedUids = () => setSelectedUids(new Set());

    const bulkDeleteSelected = async () => {
        if (!activeAccount || selectedUids.size === 0) return;

        const uids = [...selectedUids];
        const isPermanent = activeFolder === "trash" || activeFolder === "junk";
        const confirmed = window.confirm(
            isPermanent
                ? `Permanently delete ${uids.length} selected email(s)? This cannot be undone.`
                : `Move ${uids.length} selected email(s) to Trash?`
        );
        if (!confirmed) return;

        setBulkDeleting(true);
        try {
            const res = await axios.post(
                `${BASE_URL}/bulkemailaction`,
                {
                    Email: activeAccount.Email,
                    folder: activeFolder,
                    action: isPermanent ? "delete" : "trash",
                    uids,
                },
                { headers: crmHeaders() }
            );
            toast.success(res.data.message || "Bulk action completed");
            if (selectedMessage && selectedUids.has(selectedMessage.uid)) {
                setSelectedMessage(null);
                setPreviewAttachment(null);
            }
            clearSelectedUids();
            messageCacheRef.current.clear();
            fetchMessages(activeAccount, activeFolder);
            loadFolderCounts(activeAccount);
            refreshEmailNotifications();
        } catch (error) {
            toast.error(error.response?.data?.message || "Bulk delete failed");
        } finally {
            setBulkDeleting(false);
        }
    };



    const emptyTrash = async () => {

        if (!activeAccount) return;

        if (!messages.length) {

            toast.info("Trash is already empty");

            return;

        }

        const confirmed = window.confirm(

            `Permanently delete all ${messages.length} email(s) in Trash? This cannot be undone.`

        );

        if (!confirmed) return;

        setEmptyingTrash(true);

        try {

            const res = await axios.post(

                `${BASE_URL}/emptytrash`,

                { Email: activeAccount.Email },

                { headers: crmHeaders() }

            );

            toast.success(`Trash cleared (${res.data.deleted || 0} deleted)`);

            setSelectedMessage(null);

            setPreviewAttachment(null);

            fetchMessages(activeAccount, "trash");

            loadFolderCounts(activeAccount);

            refreshEmailNotifications();

        } catch (error) {

            toast.error(error.response?.data?.message || "Failed to empty trash");

        } finally {

            setEmptyingTrash(false);

        }

    };



    const fetchAttachment = async (attachmentIndex, messageCtx = null) => {
        const msg = messageCtx || selectedMessage;
        const folder = messageCtx?.folder || activeFolder;
        if (!activeAccount || !msg) return null;

        const loadKey = `${folder}:${msg.uid}:${attachmentIndex}`;
        setAttachmentLoading(loadKey);

        try {
            const res = await axios.post(
                `${BASE_URL}/getattachment`,
                {
                    Email: activeAccount.Email,
                    uid: msg.uid,
                    folder,
                    attachmentIndex,
                },
                { headers: crmHeaders() }
            );

            return res.data;
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to load attachment");
            return null;
        } finally {
            setAttachmentLoading(null);
        }
    };

    const handleViewAttachment = async (attachment, messageCtx = null) => {
        const data = await fetchAttachment(attachment.index, messageCtx);
        if (!data) return;

        const blob = base64ToBlob(data.data, data.contentType);
        const url = URL.createObjectURL(blob);

        if (previewAttachment?.url) URL.revokeObjectURL(previewAttachment.url);

        setPreviewAttachment({ ...data, url, blob });
        setReadAttachOpen(true);
    };



    const handleDownloadAttachment = async (attachment, messageCtx = null) => {
        const data = await fetchAttachment(attachment.index, messageCtx);
        if (!data) return;
        const blob = base64ToBlob(data.data, data.contentType);
        downloadBlob(blob, data.filename);
    };

    const attachmentLoadKey = (att, messageCtx = null) => {
        const msg = messageCtx || selectedMessage;
        const folder = messageCtx?.folder || activeFolder;
        return `${folder}:${msg?.uid}:${att.index}`;
    };

    const renderConversationItem = (threadMsg, idx) => {
        const isCurrent = threadMsg.isCurrent;
        const itemAttachments = isCurrent
            ? selectedMessage.attachments || threadMsg.attachments || []
            : threadMsg.attachments || [];
        const showTranslated = isCurrent && emailViewMode === "translated" && translatedEmailHtml;
        const bodyHtml = showTranslated ? translatedEmailHtml : threadMsg.body;
        const bodyIsHtml = showTranslated
            ? translatedEmailHtml.includes("<")
            : threadMsg.isHtml;

        return (
            <div
                key={`${threadMsg.folder}-${threadMsg.uid}-${idx}`}
                className={`outlook-thread-item${isCurrent ? " outlook-thread-item--current" : ""}`}
            >
                {threadMsg.replyLabel && (
                    <div className="outlook-thread-reply-label">
                        <i className="bi bi-reply-fill me-1" aria-hidden="true"></i>
                        {threadMsg.replyLabel}
                    </div>
                )}
                <div className="outlook-thread-header">
                    <span
                        className={`outlook-thread-badge ${
                            threadMsg.role === "sent"
                                ? "outlook-thread-badge--sent"
                                : "outlook-thread-badge--received"
                        }`}
                    >
                        <i
                            className={`bi ${
                                threadMsg.role === "sent" ? "bi-send-fill" : "bi-inbox-fill"
                            } me-1`}
                        ></i>
                        {threadMsg.role === "sent" ? "You sent" : "Received"}
                        {isCurrent ? " · Reading now" : ""}
                    </span>
                    <strong>{threadMsg.subject}</strong>
                    <span className="outlook-thread-date">{threadMsg.date}</span>
                </div>
                <div className="outlook-thread-meta">
                    <span>From: {threadMsg.from || "—"}</span>
                    <span>To: {threadMsg.to || "—"}</span>
                    {threadMsg.cc ? <span>Cc: {threadMsg.cc}</span> : null}
                </div>
                <div className={`outlook-thread-body outlook-read-body--${readFontSize}`}>
                    {threadMsg.bodyPending && !threadMsg.body ? (
                        <p className="outlook-thread-body-preview">
                            <strong>{threadMsg.subject || "(No subject)"}</strong>
                            <br />
                            <span>
                                {threadMsg.role === "sent" ? "You sent" : "Received"} — {threadMsg.date || ""}
                            </span>
                        </p>
                    ) : bodyIsHtml ? (
                        <div
                            className={`email-html-body${showTranslated ? " outlook-translated-body" : ""}`}
                            dangerouslySetInnerHTML={{ __html: bodyHtml }}
                        />
                    ) : (
                        <pre>{fixEmailDisplayText(bodyHtml)}</pre>
                    )}
                </div>
                {itemAttachments.length > 0 && (
                    <div className="outlook-thread-attachments">
                        <span className="outlook-thread-attachments-label">
                            <i className="bi bi-paperclip me-1"></i>
                            {itemAttachments.length} attachment
                            {itemAttachments.length !== 1 ? "s" : ""}
                        </span>
                        <div className="outlook-attachment-list outlook-attachment-list--thread">
                            {renderAttachmentItems(itemAttachments, {
                                uid: threadMsg.uid,
                                folder: threadMsg.folder || activeFolder,
                            })}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const fullConversation =
        selectedMessage?.fullConversation?.length > 1 ? selectedMessage.fullConversation : null;

    const renderAttachmentItems = (attachments, messageCtx = null) =>
        attachments.map((att) => (
            <div key={`${messageCtx?.uid || selectedMessage?.uid}-${att.index}`} className="outlook-attachment-item">
                <i className={`bi ${getAttachmentIcon(att.contentType, att.filename)}`}></i>
                <div className="outlook-attachment-name">
                    <span>{att.filename}</span>
                    {att.size > 0 && <small>{formatAttachmentSize(att.size)}</small>}
                </div>
                <button
                    type="button"
                    className="outlook-attachment-btn"
                    onClick={() => handleViewAttachment(att, messageCtx)}
                    disabled={attachmentLoading === attachmentLoadKey(att, messageCtx)}
                >
                    <i className="bi bi-eye"></i> View
                </button>
                <button
                    type="button"
                    className="outlook-attachment-btn"
                    onClick={() => handleDownloadAttachment(att, messageCtx)}
                    disabled={attachmentLoading === attachmentLoadKey(att, messageCtx)}
                >
                    <i className="bi bi-download"></i> Download
                </button>
            </div>
        ));



    const base64ToBlob = (base64, contentType) => {

        const bytes = atob(base64);

        const arr = new Uint8Array(bytes.length);

        for (let i = 0; i < bytes.length; i += 1) arr[i] = bytes.charCodeAt(i);

        return new Blob([arr], { type: contentType });

    };



    const downloadBlob = (blob, filename) => {

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");

        link.href = url;

        link.download = filename;

        link.click();

        URL.revokeObjectURL(url);

    };



    const closePreview = () => {

        if (previewAttachment?.url) URL.revokeObjectURL(previewAttachment.url);

        setPreviewAttachment(null);

    };



    const mailActionsRef = useRef({});

    mailActionsRef.current = {

        sendEmail,

        saveDraft,

        handleReply,

        handleReplyAll,

        handleNewEmail,

        moveToTrash,

        closePreview,

        setShowCompose,

        navigateListMessage,

        openFocusedOrFirstMessage,

    };



    useEffect(() => {

        const onKeyDown = (e) => {

            const tag = (e.target?.tagName || "").toLowerCase();

            const inField =

                tag === "input" ||

                tag === "textarea" ||

                tag === "select" ||

                e.target?.isContentEditable;

            const actions = mailActionsRef.current;



            if (showCompose && (e.ctrlKey || e.metaKey) && e.key === "Enter") {

                e.preventDefault();

                actions.sendEmail();

                return;

            }

            if (showCompose && (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") {

                e.preventDefault();

                actions.saveDraft();

                return;

            }

            if (e.key === "Escape") {

                if (previewAttachment) actions.closePreview();

                else if (showCompose) actions.setShowCompose(false);

                return;

            }

            if (inField) return;



            if ((e.key === "r" || e.key === "R") && selectedMessage && (activeFolder === "inbox" || activeFolder === "sent")) {

                e.preventDefault();

                if (e.shiftKey) actions.handleReplyAll();
                else actions.handleReply();

            }

            if (e.key === "n" || e.key === "N") {

                e.preventDefault();

                actions.handleNewEmail();

            }

            if (e.key === "Delete" && selectedMessage && activeFolder === "inbox") {

                e.preventDefault();

                actions.moveToTrash();

            }

            if (e.key === "ArrowDown") {

                e.preventDefault();

                actions.navigateListMessage(1);

                return;

            }

            if (e.key === "ArrowUp") {

                e.preventDefault();

                actions.navigateListMessage(-1);

                return;

            }

            if (e.key === "Enter" && !showCompose && !selectedMessage) {

                e.preventDefault();

                actions.openFocusedOrFirstMessage();

            }

        };

        window.addEventListener("keydown", onKeyDown);

        return () => window.removeEventListener("keydown", onKeyDown);

    }, [showCompose, previewAttachment, selectedMessage, activeFolder]);



    const filteredMessages = messages.filter((item) => {

        if (!searchQuery.trim()) return true;

        const q = searchQuery.toLowerCase();

        return (

            (item.from || "").toLowerCase().includes(q) ||

            (item.to || "").toLowerCase().includes(q) ||

            (item.subject || "").toLowerCase().includes(q)

        );

    });

    filteredMessagesRef.current = filteredMessages;

    const allVisibleSelected =
        filteredMessages.length > 0 && selectedUids.size === filteredMessages.length;
    const someVisibleSelected = selectedUids.size > 0;
    const bulkDeleteLabel =
        activeFolder === "trash" || activeFolder === "junk" ? "Delete Forever" : "Delete";



    const currentFolderMeta = MAIL_FOLDERS.find((f) => f.key === activeFolder) || MAIL_FOLDERS[0];
    const folderTotal = folderCounts[activeFolder] ?? totalInFolder ?? filteredMessages.length;
    const loadedCount = messages.length;
    const canLoadMore = loadedCount < folderTotal && messageLimit < 2000;

    const panelTitle = countryFilter
        ? `${countryFilter} — Incoming Email`
        : "All Incoming — Assigned Mailboxes";



    if (countryFilter && !canUseEmailForCountry(countryFilter)) {

        return (

            <div className="container p-4">

                <h3>Access Denied</h3>

                <p className="text-muted">You do not have permission to receive emails for {countryFilter}.</p>

            </div>

        );

    }



    return (

        <div className={`outlook-mail ${darkMode ? "dark-mode" : ""}`}>

            <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop />



            <aside className="outlook-accounts">

                <div className="outlook-accounts-header">

                    <div className="outlook-header-top">

                        <h5><i className="bi bi-inbox me-2"></i>{panelTitle}</h5>

                        <button

                            type="button"

                            className="outlook-dark-toggle"

                            onClick={toggleDarkMode}

                            title={darkMode ? "Switch to light mode" : "Switch to dark mode"}

                        >

                            <i className={`bi ${darkMode ? "bi-sun-fill" : "bi-moon-fill"}`}></i>

                        </button>

                    </div>

                    <p>

                        {accountsLoading

                            ? "Loading..."

                            : `${accounts.length} account${accounts.length !== 1 ? "s" : ""}${

                                  countryFilter ? ` for ${countryFilter}` : ""

                              }`}

                    </p>

                </div>



                <div className="outlook-account-list">

                    {accountsLoading && (

                        <div className="outlook-loading-inline">

                            <div className="outlook-spinner"></div>

                            Loading...

                        </div>

                    )}

                    {!accountsLoading && accounts.length === 0 && (

                        <div className="outlook-empty">

                            <i className="bi bi-envelope-x"></i>

                            <p>

                                No emails for {countryFilter || "this filter"}.

                                <br />

                                Add one from Emails menu.

                            </p>

                        </div>

                    )}

                    {accounts.map((account) => {
                        const health = getHealthForEmail(account.Email);
                        const healthClass =
                            health?.status === "blocked"
                                ? "has-health-alert"
                                : health?.status === "warning"
                                  ? "has-health-warning"
                                  : "";

                        return (
                        <button

                            key={account.Id}

                            type="button"

                            className={`outlook-account-item ${activeAccount?.Id === account.Id ? "active" : ""} ${healthClass}`}

                            onClick={() => selectAccount(account)}

                            title={
                                health?.status !== "ok"
                                    ? health?.alerts?.map((a) => a.message).join("\n")
                                    : account.Email
                            }

                        >

                            <div className="outlook-account-avatar">{getInitials(account.Email)}</div>

                            <div className="outlook-account-info">

                                <div className="outlook-account-name">

                                    {formatMailboxLabel(account.Email)}

                                    {health?.status !== "ok" && (
                                        <EmailHealthAlert health={health} compact className="ms-1" />
                                    )}

                                </div>

                                <div className="outlook-account-email" title={account.Email}>

                                    {account.Email}

                                    {account.Country ? ` · ${account.Country}` : ""}

                                </div>

                                {health?.status !== "ok" && (
                                    <EmailHealthAlert health={health} className="outlook-account-health-banner" />
                                )}

                            </div>

                            <EmailCountBadge count={byEmail[account.Email]} className="email-notif-badge--account" />

                        </button>
                        );
                    })}

                </div>



                {activeAccount && (

                    <div className="outlook-folder-nav">

                        {MAIL_FOLDERS.filter((f) => availableFolders.includes(f.key)).map((folder) => (

                            <button

                                key={folder.key}

                                type="button"

                                className={`outlook-folder-btn ${activeFolder === folder.key ? "active" : ""}`}

                                onClick={() => switchFolder(folder.key)}

                            >

                                <i className={`bi ${folder.icon}`}></i>

                                {folderCounts[folder.key] > 0 && (

                                    <span className="outlook-folder-count">{folderCounts[folder.key]}</span>

                                )}

                                {folder.label}

                            </button>

                        ))}

                    </div>

                )}

            </aside>



            <section
                className={`outlook-list ${listPanelHidden ? "outlook-list--hidden" : ""}`}
                style={listPanelHidden ? undefined : { width: listPanelWidth, minWidth: listPanelWidth }}
            >

                {!activeAccount ? (

                    <div className="outlook-empty">

                        <i className="bi bi-arrow-left-circle"></i>

                        <p>Select an email account<br />to view mail</p>

                    </div>

                ) : (

                    <>

                        {issueCount > 0 && (
                            <div
                                className={`outlook-health-global-banner ${
                                    blockedCount > 0
                                        ? "outlook-health-global-banner--blocked"
                                        : "outlook-health-global-banner--warning"
                                }`}
                                role="alert"
                            >
                                <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
                                <span>
                                    {blockedCount > 0 ? (
                                        <>
                                            <strong>{blockedCount} email account(s)</strong> par domain block ya
                                            mail server issue hai — neeche alerts dekhein.
                                        </>
                                    ) : (
                                        <>
                                            <strong>{issueCount} email account(s)</strong> par warning — neeche
                                            alerts dekhein.
                                        </>
                                    )}
                                </span>
                            </div>
                        )}

                        <div className="outlook-list-toolbar">

                            <button

                                type="button"

                                className="outlook-btn-new-mail"

                                onClick={handleNewEmail}

                                title="New Email"

                            >

                                <i className="bi bi-pencil-square"></i> New

                            </button>

                            <input

                                type="text"

                                placeholder="Search mail..."

                                value={searchQuery}

                                onChange={(e) => setSearchQuery(e.target.value)}

                            />

                            <button

                                type="button"

                                title="Refresh"

                                onClick={() => {
                                    fetchMessages(activeAccount, activeFolder);
                                    loadFolderCounts(activeAccount);
                                }}

                                disabled={messagesLoading}

                            >

                                <i className="bi bi-arrow-clockwise"></i>

                            </button>

                            {activeFolder === "trash" && messages.length > 0 && (

                                <button

                                    type="button"

                                    className="outlook-btn-empty-trash"

                                    title="Empty Trash"

                                    onClick={emptyTrash}

                                    disabled={emptyingTrash}

                                >

                                    <i className="bi bi-trash3"></i>

                                    {emptyingTrash ? "..." : "Empty"}

                                </button>

                            )}

                        </div>

                        <div className="outlook-list-header">

                            <label
                                className="outlook-select-all"
                                onClick={(e) => e.stopPropagation()}
                                title="Select all"
                            >
                                <input
                                    type="checkbox"
                                    checked={allVisibleSelected}
                                    onChange={toggleSelectAllVisible}
                                    disabled={!filteredMessages.length}
                                />
                            </label>

                            <i className={`bi ${currentFolderMeta.icon} me-1`}></i>

                            {currentFolderMeta.label} · {loadedCount} loaded

                            {folderTotal > loadedCount ? ` of ${folderTotal}` : ""} message

                            {folderTotal !== 1 ? "s" : ""}

                            {activeFolder === "inbox" && (

                                <span className="outlook-live-badge">Live</span>

                            )}

                        </div>

                        {someVisibleSelected && (
                            <div className="outlook-bulk-bar">
                                <span>{selectedUids.size} selected</span>
                                <button
                                    type="button"
                                    className="outlook-btn-delete"
                                    onClick={bulkDeleteSelected}
                                    disabled={bulkDeleting}
                                >
                                    <i className="bi bi-trash"></i>
                                    {bulkDeleting ? "Deleting..." : bulkDeleteLabel}
                                </button>
                                <button
                                    type="button"
                                    className="outlook-btn-move"
                                    onClick={clearSelectedUids}
                                    disabled={bulkDeleting}
                                >
                                    Clear
                                </button>
                            </div>
                        )}

                        <div className="outlook-message-list">

                            {messagesLoading && (

                                <div className="outlook-loading-inline">

                                    <div className="outlook-spinner"></div>

                                    Loading...

                                </div>

                            )}

                            {!messagesLoading && filteredMessages.length === 0 && (

                                <div className="outlook-empty">

                                    <i className="bi bi-envelope"></i>

                                    <p>No messages in {currentFolderMeta.label}</p>

                                </div>

                            )}

                            {!messagesLoading &&

                                filteredMessages.map((item) => (

                                    <div

                                        key={item.uid}

                                        className={`outlook-message-item ${!item.seen ? "unread" : ""} ${

                                            selectedMessage?.uid === item.uid ? "active" : ""

                                        } ${focusedListUid === item.uid && selectedMessage?.uid !== item.uid ? "focused" : ""} ${

                                            selectedUids.has(item.uid) ? "selected" : ""

                                        }`}

                                        onClick={() => {
                                            setFocusedListUid(item.uid);
                                            openMessage(item.uid);
                                        }}

                                    >

                                        <label
                                            className="outlook-msg-check"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedUids.has(item.uid)}
                                                onChange={() => toggleSelectUid(item.uid)}
                                            />
                                        </label>

                                        <div className="outlook-msg-content">

                                        <div className="outlook-msg-from">

                                            {activeFolder === "sent"

                                                ? extractSenderName(item.to || item.from)

                                                : extractSenderName(item.from)}

                                        </div>

                                        <div className="outlook-msg-subject">

                                            {item.answered && (

                                                <i className="bi bi-reply-fill outlook-replied-icon" title="You replied"></i>

                                            )}

                                            {item.hasAttachments && (
                                                <i
                                                    className="bi bi-paperclip outlook-attach-icon"
                                                    title={`${item.attachmentCount || 1} attachment(s)`}
                                                ></i>
                                            )}

                                            {item.subject}

                                        </div>

                                        <div className="outlook-msg-date">{formatDisplayDate(item.date)}</div>

                                        </div>

                                    </div>

                                ))}

                            {canLoadMore && (
                                <div className="outlook-load-more-wrap">
                                    <button
                                        type="button"
                                        className="outlook-btn-load-more"
                                        onClick={loadMoreMessages}
                                        disabled={messagesLoading}
                                    >
                                        {messagesLoading
                                            ? "Loading..."
                                            : `Load more (${loadedCount} of ${folderTotal})`}
                                    </button>
                                </div>
                            )}

                        </div>

                    </>

                )}

            </section>

            {!listPanelHidden && (
                <div
                    className="outlook-list-resizer"
                    onPointerDown={startListResize}
                    title="Drag to resize inbox list"
                    role="separator"
                    aria-orientation="vertical"
                />
            )}

            <section className="outlook-read">

                {!selectedMessage && !messageLoading && !showCompose && (

                    <div className="outlook-empty">

                        <i className="bi bi-envelope-open"></i>

                        <p>Select a message to read</p>

                    </div>

                )}



                {messageLoading && !selectedMessage && (

                    <div className="outlook-loading-inline">

                        <div className="outlook-spinner"></div>

                        Loading message...

                    </div>

                )}



                {selectedMessage && (

                    <>

                        <div className="outlook-read-toolbar">

                            <button
                                type="button"
                                className="outlook-btn-move"
                                onClick={() => setListPanelHidden((v) => !v)}
                                title={listPanelHidden ? "Show inbox list" : "Hide or show inbox list"}
                            >
                                <i className={`bi ${listPanelHidden ? "bi-layout-sidebar-inset-reverse" : "bi-layout-sidebar-inset"}`}></i>
                                {listPanelHidden ? "Show list" : "Hide list"}
                            </button>

                            {activeFolder === "junk" && (

                                <>

                                    <button

                                        type="button"

                                        className="outlook-btn-move"

                                        onClick={moveToInbox}

                                        disabled={movingEmail}

                                    >

                                        <i className="bi bi-inbox"></i>

                                        {movingEmail ? "Moving..." : "Not Junk"}

                                    </button>

                                    <button

                                        type="button"

                                        className="outlook-btn-delete"

                                        onClick={deleteEmailPermanently}

                                        disabled={deletingEmail}

                                    >

                                        <i className="bi bi-trash"></i>

                                        {deletingEmail ? "Deleting..." : "Delete Forever"}

                                    </button>

                                </>

                            )}

                            {activeFolder === "trash" && (

                                <>

                                    <button

                                        type="button"

                                        className="outlook-btn-move"

                                        onClick={moveToInbox}

                                        disabled={movingEmail}

                                    >

                                        <i className="bi bi-inbox"></i>

                                        {movingEmail ? "Restoring..." : "Restore"}

                                    </button>

                                    <button

                                        type="button"

                                        className="outlook-btn-delete"

                                        onClick={deleteEmailPermanently}

                                        disabled={deletingEmail}

                                    >

                                        <i className="bi bi-trash"></i>

                                        {deletingEmail ? "Deleting..." : "Delete Forever"}

                                    </button>

                                </>

                            )}

                            {(activeFolder === "inbox" || activeFolder === "sent") && (

                                <>

                                    <button
                                        type="button"
                                        className="outlook-btn-move"
                                        onClick={() => navigateListMessage(-1)}
                                        title="Previous email (↑)"
                                    >
                                        <i className="bi bi-arrow-up"></i>
                                    </button>

                                    <button
                                        type="button"
                                        className="outlook-btn-move"
                                        onClick={() => navigateListMessage(1)}
                                        title="Next email (↓)"
                                    >
                                        <i className="bi bi-arrow-down"></i>
                                    </button>

                                    <button type="button" className="outlook-btn-reply" onClick={handleReply}>

                                        <i className="bi bi-reply"></i> Reply

                                    </button>

                                    <button
                                        type="button"
                                        className="outlook-btn-reply outlook-btn-reply-all"
                                        onClick={handleReplyAll}
                                        title="Reply to all recipients"
                                    >
                                        <i className="bi bi-reply-all"></i> Reply All
                                    </button>

                                    {activeFolder === "inbox" && (
                                    <button
                                        type="button"
                                        className="outlook-btn-ai-reply"
                                        onClick={handleReplyWithAi}
                                        disabled={aiSuggestLoading}
                                    >
                                        <i className={`bi ${aiSuggestLoading ? "bi-hourglass-split" : "bi-stars"}`}></i>
                                        {aiSuggestLoading ? "Generating..." : "Reply with AI"}
                                    </button>
                                    )}

                                    <button
                                        type="button"
                                        className="outlook-btn-move"
                                        onClick={markAsUnread}
                                        title="Mark as unread"
                                    >
                                        <i className="bi bi-envelope"></i> Unread
                                    </button>

                                    <button

                                        type="button"

                                        className="outlook-btn-delete"

                                        onClick={moveToTrash}

                                        disabled={movingEmail}

                                    >

                                        <i className="bi bi-trash"></i>

                                        {movingEmail ? "Deleting..." : "Delete"}

                                    </button>

                                </>

                            )}

                        </div>



                        <div className="outlook-read-header">

                            {activeAccountHealth?.status !== "ok" && (
                                <EmailHealthAlert
                                    health={activeAccountHealth}
                                    className="outlook-read-health-banner mb-2"
                                />
                            )}

                            <h2 className="outlook-read-subject">{selectedMessage.subject}</h2>

                            <div className="outlook-read-meta">

                                <div><strong>From:</strong> {selectedMessage.from}</div>

                                <div><strong>To:</strong> {selectedMessage.to}</div>

                                {selectedMessage.cc ? (
                                    <div><strong>Cc:</strong> {selectedMessage.cc}</div>
                                ) : null}

                                <div><strong>Date:</strong> {selectedMessage.date}</div>

                            </div>

                        </div>



                        {fullConversation ? (
                            <div className="outlook-thread-block outlook-thread-block--full">
                                <div className="outlook-thread-title">
                                    <i className="bi bi-chat-left-text me-1"></i>
                                    Full conversation ({fullConversation.length} messages)
                                </div>
                                {fullConversation.map((threadMsg, idx) => renderConversationItem(threadMsg, idx))}
                            </div>
                        ) : selectedMessage.thread?.length > 0 ? (
                            <div className="outlook-thread-block">
                                <div className="outlook-thread-title">
                                    <i className="bi bi-chat-left-text me-1"></i>
                                    Conversation ({selectedMessage.thread.length + 1} messages)
                                </div>
                                {selectedMessage.thread.map((threadMsg, idx) => renderConversationItem(threadMsg, idx))}
                                <div className="outlook-thread-divider">
                                    <span>Latest message</span>
                                </div>
                            </div>
                        ) : null}



                        {!fullConversation && selectedMessage.attachments?.length > 0 && (

                            <div className="outlook-attachments outlook-read-attach-dropdown">

                                <button
                                    type="button"
                                    className="outlook-read-attach-toggle"
                                    onClick={() => setReadAttachOpen((v) => !v)}
                                    aria-expanded={readAttachOpen}
                                >
                                    <i className="bi bi-paperclip"></i>
                                    {selectedMessage.attachments.length} attachment
                                    {selectedMessage.attachments.length !== 1 ? "s" : ""}
                                    {" "}
                                    ({formatAttachmentSize(totalAttachmentSize(selectedMessage.attachments))})
                                    <i className={`bi bi-chevron-${readAttachOpen ? "up" : "down"} ms-auto`}></i>
                                </button>

                                {readAttachOpen && (
                                    <div className="outlook-attachment-list">
                                    {renderAttachmentItems(selectedMessage.attachments)}
                                    </div>
                                )}

                            </div>

                        )}



                        {previewAttachment && (
                            <div className="outlook-attachment-inline">
                                <div className="outlook-attachment-inline-header">
                                    <span><i className="bi bi-paperclip me-1"></i>{previewAttachment.filename}</span>
                                    <div className="outlook-attachment-inline-actions">
                                        <button
                                            type="button"
                                            onClick={() =>
                                                downloadBlob(previewAttachment.blob, previewAttachment.filename)
                                            }
                                            title="Download"
                                        >
                                            <i className="bi bi-download"></i>
                                        </button>
                                        <button type="button" onClick={closePreview} title="Close preview">
                                            <i className="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="outlook-attachment-inline-body">
                                    {previewAttachment.contentType.startsWith("image/") && (
                                        <img src={previewAttachment.url} alt={previewAttachment.filename} />
                                    )}
                                    {previewAttachment.contentType === "application/pdf" && (
                                        <iframe src={previewAttachment.url} title={previewAttachment.filename} />
                                    )}
                                    {previewAttachment.contentType.startsWith("text/") && (
                                        <iframe src={previewAttachment.url} title={previewAttachment.filename} />
                                    )}
                                    {previewAttachment.contentType.startsWith("audio/") && (
                                        <audio controls src={previewAttachment.url} />
                                    )}
                                    {previewAttachment.contentType.startsWith("video/") && (
                                        <video controls src={previewAttachment.url} />
                                    )}
                                    {!previewAttachment.contentType.startsWith("image/") &&
                                        previewAttachment.contentType !== "application/pdf" &&
                                        !previewAttachment.contentType.startsWith("text/") &&
                                        !previewAttachment.contentType.startsWith("audio/") &&
                                        !previewAttachment.contentType.startsWith("video/") && (
                                            <div className="outlook-attachment-fallback">
                                                <i className={`bi ${getAttachmentIcon(previewAttachment.contentType, previewAttachment.filename)} outlook-attachment-fallback-icon`}></i>
                                                <p>Inline preview is not available for this file type.</p>
                                                <button
                                                    type="button"
                                                    className="outlook-btn-reply"
                                                    onClick={() =>
                                                        downloadBlob(
                                                            previewAttachment.blob,
                                                            previewAttachment.filename
                                                        )
                                                    }
                                                >
                                                    <i className="bi bi-download me-1"></i> Download file
                                                </button>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}



                        <div className="outlook-read-body-toolbar">
                            <span className="outlook-read-body-toolbar-label">
                                <i className="bi bi-translate me-1"></i>
                                {detectedLanguage
                                    ? detectedLanguage.name
                                    : "Language"}
                            </span>
                            <button
                                type="button"
                                className="outlook-btn-translate"
                                onClick={handleDetectLanguage}
                                disabled={translateLoading}
                                title="Detect email language"
                            >
                                Detect
                            </button>
                            <select
                                className="outlook-translate-select"
                                value={translateTarget}
                                onChange={(e) => setTranslateTarget(e.target.value)}
                                disabled={translateLoading}
                            >
                                {TRANSLATE_LANGUAGES.map((lang) => (
                                    <option key={lang.code} value={lang.code}>
                                        {lang.label}
                                    </option>
                                ))}
                            </select>
                            <button
                                type="button"
                                className="outlook-btn-translate"
                                onClick={handleTranslateEmail}
                                disabled={translateLoading}
                            >
                                {translateLoading ? "..." : "Translate"}
                            </button>
                            {emailViewMode === "translated" && (
                                <button
                                    type="button"
                                    className="outlook-btn-translate outlook-btn-translate--revert"
                                    onClick={() => setEmailViewMode("original")}
                                >
                                    Show original
                                </button>
                            )}
                            <span className="outlook-read-body-toolbar-divider" />
                            <span className="outlook-read-body-toolbar-label">
                                <i className="bi bi-type me-1"></i> Text size
                            </span>
                            <div className="outlook-read-font-btns">
                                <button
                                    type="button"
                                    className={readFontSize === "sm" ? "active" : ""}
                                    onClick={() => setReadFontSizePersist("sm")}
                                    title="Smaller text"
                                >
                                    A−
                                </button>
                                <button
                                    type="button"
                                    className={readFontSize === "md" ? "active" : ""}
                                    onClick={() => setReadFontSizePersist("md")}
                                    title="Normal text"
                                >
                                    A
                                </button>
                                <button
                                    type="button"
                                    className={readFontSize === "lg" ? "active" : ""}
                                    onClick={() => setReadFontSizePersist("lg")}
                                    title="Larger text"
                                >
                                    A+
                                </button>
                            </div>
                        </div>

                        {!fullConversation && (
                        <div className={`outlook-read-body outlook-read-body--${readFontSize}`}>

                            {messageLoading ? (
                                <div className="outlook-loading-inline">
                                    <div className="outlook-spinner"></div>
                                    Loading message...
                                </div>
                            ) : emailViewMode === "translated" ? (
                                <div className="email-html-body outlook-translated-body">
                                    {translatedEmailHtml.includes("<")
                                        ? (
                                            <div dangerouslySetInnerHTML={{ __html: translatedEmailHtml }} />
                                        )
                                        : (
                                            <pre>{translatedEmailHtml.replace(/<br>/g, "\n")}</pre>
                                        )}
                                </div>
                            ) : selectedMessage.isHtml ? (

                                <div

                                    className="email-html-body"

                                    dangerouslySetInnerHTML={{ __html: selectedMessage.body }}

                                />

                            ) : (

                                <pre>{fixEmailDisplayText(selectedMessage.body)}</pre>

                            )}

                        </div>
                        )}

                    </>

                )}



            </section>



            {showCompose && (

                <div

                    className="outlook-compose-overlay"

                    onClick={(e) => e.target === e.currentTarget && setShowCompose(false)}

                >

                    <div className="outlook-compose-modal" role="dialog" aria-modal="true">

                        <div className="outlook-compose-header">

                            <div className="outlook-compose-header-main">

                                <div className="outlook-compose-header-icon">

                                    <i className={`bi ${composeMode === "new" ? "bi-envelope-plus" : "bi-reply-fill"}`}></i>

                                </div>

                                <div>

                                    <h6>
                                        {composeMode === "new"
                                            ? "Compose New Email"
                                            : composeMode === "replyAll"
                                              ? "Reply All"
                                              : "Reply to Message"}
                                    </h6>

                                    <span className="outlook-compose-from">

                                        From: {activeAccount?.Email || "—"}

                                    </span>

                                </div>

                            </div>

                            <button

                                type="button"

                                className="outlook-compose-close"

                                onClick={() => setShowCompose(false)}

                                aria-label="Close compose"

                            >

                                <i className="bi bi-x-lg"></i>

                            </button>

                        </div>



                        <div className="outlook-compose-body">

                            <div className="outlook-compose-row">

                                <label className="outlook-compose-row-label">

                                    To <span className="outlook-label-required">*</span>

                                </label>

                                <input

                                    type="email"

                                    className="outlook-compose-row-input"

                                    value={replyTo}

                                    onChange={(e) => setReplyTo(e.target.value)}

                                    readOnly={composeMode === "reply"}

                                    placeholder="recipient@example.com"

                                    autoFocus={composeMode === "new"}

                                />

                            </div>



                            {!showCcBcc && (composeMode === "new" || composeMode === "reply") ? (

                                <button

                                    type="button"

                                    className="outlook-compose-toggle-cc"

                                    onClick={() => setShowCcBcc(true)}

                                >

                                    <i className="bi bi-plus-circle"></i> Add Cc / Bcc

                                </button>

                            ) : (

                                <>

                                    <div className="outlook-compose-row">

                                        <label className="outlook-compose-row-label">

                                            Cc <span className="outlook-label-optional">optional</span>

                                        </label>

                                        <input

                                            type="text"

                                            className="outlook-compose-row-input"

                                            value={replyCc}

                                            onChange={(e) => setReplyCc(e.target.value)}

                                            placeholder="cc@example.com"

                                        />

                                    </div>

                                    <div className="outlook-compose-row">

                                        <label className="outlook-compose-row-label">

                                            Bcc <span className="outlook-label-optional">optional</span>

                                        </label>

                                        <input

                                            type="text"

                                            className="outlook-compose-row-input"

                                            value={replyBcc}

                                            onChange={(e) => setReplyBcc(e.target.value)}

                                            placeholder="bcc@example.com"

                                        />

                                    </div>

                                </>

                            )}



                            <div className="outlook-compose-row">

                                <label className="outlook-compose-row-label">

                                    Subject <span className="outlook-label-optional">optional</span>

                                </label>

                                <input

                                    type="text"

                                    className="outlook-compose-row-input"

                                    value={replySubject}

                                    onChange={(e) => setReplySubject(e.target.value)}

                                    placeholder="Email subject"

                                />

                            </div>



                            <div className="outlook-compose-message-wrap">

                                <label className="outlook-compose-row-label">

                                    Message <span className="outlook-label-required">*</span>
                                    {aiSuggestLoading && (
                                        <span className="outlook-ai-compose-loading">
                                            <i className="bi bi-stars"></i> AI drafting reply...
                                        </span>
                                    )}

                                </label>

                                <RichTextToolbar editorRef={composeEditorRef} className="outlook-rich-toolbar" />
                                <RichTextEditor
                                    editorRef={composeEditorRef}
                                    className={`outlook-compose-message outlook-rich-editor${aiSuggestLoading ? " outlook-compose-message--loading" : ""}`}
                                    placeholder={
                                        aiSuggestLoading
                                            ? "AI is writing a human-like reply for you..."
                                            : composeMode === "new"
                                              ? "Write your message here..."
                                              : "Write your reply here..."
                                    }
                                />

                            </div>



                            <div className="outlook-compose-attachments">

                                <input

                                    ref={composeFileInputRef}

                                    type="file"

                                    multiple

                                    hidden

                                    onChange={handleAddAttachments}

                                />

                                <button

                                    type="button"

                                    className="outlook-btn-attach"

                                    onClick={() => composeFileInputRef.current?.click()}

                                >

                                    <i className="bi bi-paperclip"></i> Attach files

                                    <span className="outlook-compose-attach-hint">Max 50MB each</span>

                                </button>



                                {composeAttachments.length > 0 && (

                                    <div className="outlook-compose-attachment-dropdown">

                                        <button
                                            type="button"
                                            className="outlook-compose-attachment-toggle"
                                            onClick={() => setShowAttachDropdown((v) => !v)}
                                            aria-expanded={showAttachDropdown}
                                        >
                                            <i className="bi bi-paperclip"></i>
                                            {composeAttachments.length} attachment
                                            {composeAttachments.length !== 1 ? "s" : ""}
                                            {" "}({formatAttachmentSize(totalAttachmentSize(composeAttachments))})
                                            <i className={`bi bi-chevron-${showAttachDropdown ? "up" : "down"} ms-auto`}></i>
                                        </button>

                                        {showAttachDropdown && (
                                            <div className="outlook-compose-attachment-list">

                                        {composeAttachments.map((file, index) => (

                                            <div key={`${file.name}-${index}`} className="outlook-compose-attachment-item">

                                                <i className="bi bi-file-earmark-text"></i>

                                                <div className="outlook-compose-attachment-meta">

                                                    <span>{file.name}</span>

                                                    <small>{formatAttachmentSize(file.size)}</small>

                                                </div>

                                                <button

                                                    type="button"

                                                    className="outlook-compose-attachment-remove"

                                                    onClick={() => removeComposeAttachment(index)}

                                                    title="Remove attachment"

                                                >

                                                    <i className="bi bi-x"></i>

                                                </button>

                                            </div>

                                        ))}

                                            </div>
                                        )}

                                    </div>

                                )}

                            </div>



                            <div className="outlook-compose-signature">

                                <div className="outlook-compose-signature-actions">

                                    <button type="button" className="outlook-btn-signature" onClick={insertSignature}>
                                        <i className="bi bi-pen"></i> Insert signature
                                    </button>

                                    <button
                                        type="button"
                                        className="outlook-compose-toggle-cc"
                                        onClick={() => setShowSignatureEditor((v) => !v)}
                                    >
                                        {showSignatureEditor ? "Hide signature editor" : "Edit signature"}
                                    </button>

                                </div>

                                {showSignatureEditor && (
                                    <div className="outlook-compose-signature-editor">
                                        <p className="outlook-signature-hint">
                                            Paste or upload PNG/JPG — click image and drag corners to resize. Hold Shift to lock ratio.
                                        </p>
                                        <input
                                            ref={signatureImageInputRef}
                                            type="file"
                                            accept="image/png,image/jpeg,image/jpg,image/avif,image/webp,image/gif"
                                            hidden
                                            onChange={handleSignatureImageUpload}
                                        />
                                        <button
                                            type="button"
                                            className="outlook-btn-signature"
                                            onClick={() => signatureImageInputRef.current?.click()}
                                        >
                                            <i className="bi bi-image"></i> Upload signature image
                                        </button>
                                        {showSignatureImageResize && (
                                            <ImageResizeBar
                                                label="Signature image width"
                                                width={signatureImageWidth}
                                                onWidthChange={handleSignatureImageWidthChange}
                                                onClose={() => {
                                                    setShowSignatureImageResize(false);
                                                    selectedSignatureImageRef.current = null;
                                                }}
                                            />
                                        )}
                                        <div
                                            ref={signatureEditorRef}
                                            className="outlook-signature-rich-editor"
                                            contentEditable
                                            suppressContentEditableWarning
                                            onClick={handleSignatureEditorClick}
                                            onPaste={handleSignaturePaste}
                                        />
                                        <button type="button" className="outlook-btn-draft" onClick={handleSaveSignature}>
                                            Save signature
                                        </button>
                                    </div>
                                )}

                            </div>



                            <label className="outlook-read-receipt-check">

                                <input

                                    type="checkbox"

                                    checked={requestReadReceipt}

                                    onChange={(e) => setRequestReadReceipt(e.target.checked)}

                                />

                                <span className="outlook-read-receipt-text">

                                    <i className="bi bi-envelope-check"></i>

                                    Request read receipt

                                    <small>Notify when the recipient opens this email</small>

                                </span>

                            </label>

                        </div>



                        <div className="outlook-compose-footer">

                            <div className="outlook-compose-actions">

                                <button

                                    type="button"

                                    className="outlook-btn-send"

                                    onClick={sendEmail}

                                    disabled={sendingReply || aiSuggestLoading}

                                >

                                    <i className="bi bi-send-fill"></i>

                                    {sendingReply ? "Sending..." : aiSuggestLoading ? "Wait for AI..." : "Send Email"}

                                </button>

                                <button

                                    type="button"

                                    className="outlook-btn-draft"

                                    onClick={saveDraft}

                                    disabled={savingDraft}

                                >

                                    <i className="bi bi-file-earmark"></i>

                                    {savingDraft ? "Saving..." : "Save Draft"}

                                </button>

                                <button

                                    type="button"

                                    className="outlook-btn-cancel"

                                    onClick={() => setShowCompose(false)}

                                >

                                    Discard

                                </button>

                            </div>

                            <span className="outlook-compose-footer-hint">

                                Ctrl+Enter send · Ctrl+S draft · N new · R reply · Shift+R reply all · Esc close

                            </span>

                        </div>

                    </div>

                </div>

            )}

        </div>

    );

}


